export const ALLOWED_FILE_TYPES = [
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // xlsx
  "text/plain", // txt
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // docx
  "message/rfc822" // eml
];

export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB in bytes
export const MAX_FILENAME_LENGTH = 80;

export const SUPPORTED_FILE_TYPES_STRING = "PDF, XLSX, TXT, DOCX, EML";
